import CenteredContainer from "@core/components/layout/centeredContainer";
import { AuthSplitLayout } from "../components/auth-split-layout";
import DistributorLogin from "../components/login-form";

export default function Login() {
  return (
    <CenteredContainer>
      <AuthSplitLayout>
        <DistributorLogin />
      </AuthSplitLayout>
    </CenteredContainer>
  );
}
